// extracted by mini-css-extract-plugin
export var card = "styles-module__card___MMhQs";